import { render } from "./Study_monitoring.vue?vue&type=template&id=2c1e295e&scoped=true"
import script from "./Study_monitoring?vue&type=script&lang=js"
export * from "./Study_monitoring?vue&type=script&lang=js"

import "./Study_monitoring.vue?vue&type=style&index=0&id=2c1e295e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1e295e"]])

export default __exports__